import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Chip, Icon, Stack, Typography } from 'investira.react.components';
import { ROUTES_INDICADORES_TIPO } from '../../../enums';

/** Localiza os metadados visuais do tipo apresentado na sugestão. */
function pvGetTipo(pTipoId) {
  return Object.values(ROUTES_INDICADORES_TIPO).find(pTipo => pTipo.id === pTipoId) || null;
}

/** Apresenta uma sugestão da pesquisa de indicadores. */
const SearchIndicadoresItem = memo(pProps => {
  const { indicador, onClick } = pProps;
  const xTipo = pvGetTipo(indicador.indicador_tipo_id);

  return (
    <Stack
      id={indicador.indicador_id}
      direction="row"
      flexGrow={1}
      spacing={3}
      alignItems="flex-start"
      component="li"
      onClick={onClick}
      sx={{
        px: 2,
        py: 2,
        cursor: 'pointer',
        '&:hover': { color: 'gray', backgroundColor: 'background.main' },
        borderBottom: '1px solid',
        borderBottomColor: 'background.main'
      }}>
      <Stack
        backgroundColor="primary.main"
        width="36px"
        height="36px"
        flexShrink={0}
        justifyContent="center"
        alignItems="center"
        borderRadius="8px">
        {xTipo && <Icon iconName={xTipo.iconName} color="secondary" size={18} />}
      </Stack>
      <Stack flexGrow={1}>
        <Typography variant="body2" color="textPrimary" sx={{ fontWeight: 600 }}>
          {indicador.indicador_sigla || indicador.indicador_id}
        </Typography>
        <Typography
          variant="caption"
          color="textPrimary"
          sx={{ display: { xs: 'none', sm: 'inline-block' } }}>
          {indicador.indicador}
        </Typography>
      </Stack>
      {xTipo && (
        <Stack justifyContent="end">
          <Chip label={xTipo.descricao} size="small" color="primary" />
        </Stack>
      )}
    </Stack>
  );
});

SearchIndicadoresItem.propTypes = {
  indicador: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
};

SearchIndicadoresItem.displayName = 'SearchIndicadoresItem';

export default SearchIndicadoresItem;
